import { createGetAPI, createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { useGet, invalidate } = createGetAPI({
  getURL: id => `${BASE_URL}/teachers/${id}/trial-profile`,
});

const { usePost } = createPostAPI({
  getURL: (_, id) => `${BASE_URL}/teachers/${id}/trial-profile`,
});

export {
  useGet as useGetTrialProfile,
  usePost as usePostTrialProfile,
  invalidate as invalidateTrialProfile,
};
